import { Component, OnInit, ViewChild, Injector, ChangeDetectorRef } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from 'src/app/shared/common.service';
import { Global } from 'src/app/Global';
import saveAs from 'file-saver';
import { HTTPStatus } from 'src/app/Common/app-token-handler';
import { AppErrorHandler } from 'src/app/Common/app-error-handler';
import { ServiceRequestService } from 'src/app/shared/service-request.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SearchViewComponent } from 'src/app/out-of-application/search-view/search-view.component';

@Component({
  selector: 'app-viewmyservicerequest',
  templateUrl: './viewmyservicerequest.component.html',
  styleUrls: ['./viewmyservicerequest.component.scss']
})
export class ViewmyservicerequestComponent implements OnInit {

  // version = VERSION;
  pageID: string
  selectedSR: any;
  SearchViewDialogRef: MatDialogRef<SearchViewComponent>;
  ServiceRequestForm: UntypedFormGroup;
  IsCloseTapped = false;
  isLoadingResults = false;
  statusList: any;
  array: any;
  searchParameter: any
  displayedColumns = ['SRNumber', 'CreatedOn', 'LongDescription', 'Requester', 'OnBehalfOfRequester', 'ShortDescription',
    'RequesterGPN', 'AssignmentGroup', 'TicketStatus', 'AssignedTo'];

  SRDataSource: MatTableDataSource<any[]>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  constructor(private _fb: UntypedFormBuilder, private _router: Router, public _global: Global,
    private _activeRoute: ActivatedRoute, public _commonService: CommonService, private error: AppErrorHandler,
    injector: Injector, private status: HTTPStatus, private _serviceRequestService: ServiceRequestService, private _dialog: MatDialog,
    private cdRef: ChangeDetectorRef) { }

  ngOnInit() {
    this.pageID = this._activeRoute.snapshot.paramMap.get('ID');
    //this.paginator.showFirstLastButtons = true;
    //this.paginator.pageSize = this._global.RecordSize;

    this.ServiceRequestForm = this._fb.group({

      Status: [],
      PageNumber: (this._global.pageIndex),
      PageID: (this.pageID),
      IsExport: 0,
      FilterList: this._fb.array([]),
      RecordSize: this._global.RecordSize
    });
    this.LoadFilterDetail();
  }
  ngAfterViewInit() {
    if (this.paginator) {
      this.paginator.pageSize = this._global.RecordSize;
      this.paginator.showFirstLastButtons = true;
    }
  }
  SearchRecord() {
    this._global.pageIndex = 1;
    this._global.length = 0;
    this._global.totalPage = 0;
    this.searchParameter = this.ServiceRequestForm;
    this.ServiceRequestForm.controls.PageNumber.setValue(this._global.pageIndex);
    this.LoadAllServiceRequestList(this.ServiceRequestForm.value);
  }
  LoadAllServiceRequestList(searchParameter) {
    if (!this.IsCloseTapped) {
      this.status.setHttpStatus(true);

    } else {
      this.IsCloseTapped = false;
      //this.status.setHttpStatus(false);
    }
    if (this._global.pageIndex === 0) {
      this._global.pageIndex = 1;
    }
    if (this.searchParameter != undefined) {
      this.searchParameter.PageNumber = this._global.pageIndex;
      this.searchParameter.RecordSize = this._global.RecordSize;
    }
    this.ServiceRequestForm.controls.PageNumber.setValue(this._global.pageIndex - 1);
    this._serviceRequestService.GetAllServiceRequest(searchParameter).subscribe(data => {
      if (data.RequestData != null && data.RequestData.length > 0) {
        this.SRDataSource = new MatTableDataSource(data.RequestData);
        if (this._global.length === 0) {
          this._global.length = data.TotalRecordCount;
          this.SRDataSource.paginator = this.paginator;
          this._global.totalPage = Math.ceil(this._global.length / this.paginator.pageSize);
          this.SRDataSource.sort = this.sort;
        } else {
          this.paginator.pageIndex = this._global.pageIndex - 1;
          this.status.setHttpStatus(false);
        }
      } else {
        this.SRDataSource = new MatTableDataSource(data.RequestData);
        this._global.length = data.TotalRecordCount;
        this.paginator.pageSize = this._global.RecordSize;
        this._global.pageIndex = 0;
        this._global.totalPage = 0;
        this.cdRef.detectChanges();
      }
    }, (error) => {
      this.status.setHttpStatus(false);
      this.error.handleError(error);
    }, () => { this.status.setHttpStatus(false); });
  }
  ShowDetails(row: any) {
    this._router.navigate(['/MyServiceRequest', row.RequestEntityId]);
  }
  onPaginateChange(e: any) {
    this._global.RecordSize = (e.pageSize);
    this._global.pageIndex = (e.pageIndex + 1);
    this.LoadAllServiceRequestList(this.searchParameter);
  }

  SearchSR() {
    let objForSearchData;
    if (!this.CheckForNullEmptyAndUndefined(this.selectedSR)) {
      objForSearchData = {
        PageID: this.pageID,
        FilterList: [{
          'FilterColumnsID': "15",
          'SearchText': this.selectedSR,
          'FilterColumnsDisplay': "SR Number",
          'FilterColumnsOriginal': "SRNumber",
          'FilterContainValues': "1",
          'FilterContainDisplayText': "Contains",
          'Operators': "AND",
          'DataType': undefined,
          'ParameterName': "SRNumber"
        }]
      };

      this._global.pageIndex = 1;
      this._global.length = 0;
      this._global.totalPage = 0;
      this.ServiceRequestForm.controls.PageNumber.setValue(this._global.pageIndex);
      this.LoadAllServiceRequestList(objForSearchData);
    }
    else {
      objForSearchData = {
        PageID: this.pageID,
        FilterList: [{
          'FilterColumnsID': "",
          'SearchText': "",
          'FilterColumnsDisplay': "",
          'FilterColumnsOriginal': "",
          'FilterContainValues': "",
          'FilterContainDisplayText': "",
          'Operators': "",
          'DataType': undefined,
          'ParameterName': ""
        }]
      };
      this.LoadAllServiceRequestList(objForSearchData);
    }

  }
  CheckForNullEmptyAndUndefined(value: any): boolean {
    if (value != null && value != '' && value != undefined)
      return false
    else
      return true
  }
  GoToPage() {
    if (this._global.pageIndex <= 0) { this._global.pageIndex = 1; } else if
      (this._global.pageIndex > this._global.totalPage) {
      this._global.pageIndex = this._global.totalPage;
    }
    // this.LoadAllServiceRequestList();
  }
  openSearchDialog() {
    this.SearchViewDialogRef = this._dialog.open(SearchViewComponent, {
      height: '300px',
      width: '800px',
      data: { pageid: this.pageID, data: this.searchParameter }
    });

    this.SearchViewDialogRef.afterClosed().subscribe(result => {
      if (result != undefined) {
        this.searchParameter = result;
        this.IsCloseTapped = true;
        this.LoadAllServiceRequestList(this.searchParameter.value);
      }
    })
  }

  LoadFilterDetail() {
    this._serviceRequestService.GetUserWiseFilterDetail(this.ServiceRequestForm.value).subscribe(data => {

      if (data != undefined) {
        this.searchParameter = data;
        this.searchParameter.PageID = this.pageID;

        this.LoadAllServiceRequestList(this.searchParameter);
      }
      else {
        this.SearchRecord();
      }
      this.cdRef.detectChanges();

    }, (error) => {

      this.error.handleError(error);
    });
  }
  Export() {
    this.ServiceRequestForm.controls.IsExport.setValue(1);
    this._serviceRequestService.ExportData(this.ServiceRequestForm.value).subscribe(x => {
      const blob = new Blob([x], { type: 'application/octet-stream' });
      saveAs(blob, 'ServiceRequest.xls');
    });
  }
  public handlePage(e: any) {
    this._global.pageIndex = e.pageIndex;
    this._global.RecordSize = e.pageSize;
    this.iterator();
  }

  private iterator() {
    const end = (this._global.pageIndex + 1) * this._global.RecordSize;
    const start = this._global.pageIndex * this._global.RecordSize;
    const part = this.array.slice(start, end);
    this.LoadAllServiceRequestList(this.searchParameter);
  }
}

